import { combineProps } from '../../utils';
import { useId } from '../useId';
var MOVE_ATTR_KEY = 'data-move-focused';
/**
 * when focus in container below element with binding `getItemProps`,
 * that will only have one element can be focusable.
 */
export var useOnlyOneFocusable = function (_a) {
    var focusedIndexRef = _a.focusedIndexRef, containerRef = _a.containerRef;
    var moveFocusedId = useId(MOVE_ATTR_KEY, true);
    var getIndexElm = function (toIndex) { var _a; return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[" + moveFocusedId + "=\"" + toIndex + "\"]"); };
    var setIndexTabIndex = function (toIndex) {
        var _a;
        var toElm = getIndexElm(toIndex);
        if (toElm) {
            var prevElm = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("[" + moveFocusedId + "][tabindex=\"0\"]");
            prevElm === null || prevElm === void 0 ? void 0 : prevElm.setAttribute('tabindex', '-1');
            toElm.setAttribute('tabindex', '0');
        }
    };
    // * retry when not get target element
    var focusIndex = function (toIndex) {
        var toElm = getIndexElm(toIndex);
        toElm === null || toElm === void 0 ? void 0 : toElm.focus();
    };
    return {
        moveFocusedId: moveFocusedId,
        focusIndex: focusIndex,
        setIndexTabIndex: setIndexTabIndex,
        getItemProps: function (index, options) {
            var _a;
            return combineProps((_a = {},
                _a[moveFocusedId] = index,
                _a.tabIndex = index === focusedIndexRef.current ? 0 : -1,
                _a.onFocus = function () {
                    focusedIndexRef.current = index;
                    setIndexTabIndex(index);
                },
                _a), options);
        },
    };
};
